import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import * as R from "ramda";

import Emptylustration from '../../../../assets/images/svg/057-contract-1.svg';

import { DateWithModal } from '../../../../_common/dateWithModal';
import { PaiementPartnersTableFilter } from './filter';
import { PaiementPartnersTableNav } from './nav';
import { PaiementPartnersTableRow } from './row';
import { LoadingState } from '../../../../_common/loadingState';
import * as Loadings from '../../../../constants/loadings/backoffice/payments';



export const PaiementPartnersTable = ({ paymentState, pageSearch, setPageSearch, date, setDate, routerQuery }) => {
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [invoicesToDisplay, setinvoicesToDisplay] = useState(paymentState.partnersInvoices);
    const [filters, setFilters] = useState({
        order: {
            column: "number",
            asc: true
        },
        status: undefined,
        date: {
            startDate: undefined,
            endDate: undefined
        },
        search: "",
    });


    useEffect(() => {



        let temp = paymentState.partnersInvoices.filter(i => i.amount !== 0);
        // let temp = paymentState.partnersInvoices;

        // if (!R.isNil(filters.status)) {
        //     temp = temp.filter(partner => partner.paid === filters.status);
        // }

        // if (filters.order.asc) {

        //     temp = R.sort(R.ascend(R.prop(filters.order.column)), temp);

        // } else {

        //     temp = R.sort(R.descend(R.prop(filters.order.column)), temp);

        // }

        // if (!R.isNil(filters.date.startDate)) {
        //     temp = temp.filter(invoice => invoice.created >= filters.date.startDate);
        // }

        // if (!R.isNil(filters.date.endDate)) {
        //     temp = temp.filter(invoice => invoice.created <= filters.date.endDate);
        // }

        // if (!R.isEmpty(filters.search)) {
        //     temp = temp.filter(invoice => invoice.partnerName?.toLowerCase().includes(filters.search.toLowerCase()) || invoice.etablissementName?.toLowerCase().includes(filters.search.toLowerCase()));
        // }


        setinvoicesToDisplay(temp);


    }, [filters, paymentState.partnersInvoices]);

    return (
        <div className="container-fluid h-100 ">
            <PaiementPartnersTableFilter filters={filters} setFilters={setFilters} pageSearch={pageSearch} setPageSearch={setPageSearch} date={date} setDate={setDate} routerQuery={routerQuery} />
            {
                paymentState.isLoading.includes(Loadings.FETCHING_PARTNERS_INVOICES) ?
                    <LoadingState />
                    :
                    <section className="block">
                        {!R.isEmpty(invoicesToDisplay) ?
                            <>
                                <PaiementPartnersTableNav filters={filters} setFilters={setFilters} paymentState={paymentState} routerQuery={routerQuery} />
                                {invoicesToDisplay.map(invoice => (
                                    <PaiementPartnersTableRow key={invoice.id} pdfUrl={invoice.pdfUrl} issuerId={invoice.issuerId} amount={invoice.amount} created={invoice.created} recipientType={invoice.recipientType} paid={invoice.paid} invoiceId={invoice.id} partnerName={invoice.partnerName} etablissementName={invoice.etablissementName} isDueToAssista={invoice.isDueToAssista} />
                                ))}
                            </>
                            :
                            <section className="block fs-3 text-center m-auto py-4">
                                <img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
                                <div className="block text-center container-thin mx-auto mb-auto">
                                    <h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas de factures.</h1>
                                </div>
                            </section>
                        }
                    </section>}
        </div>
    );
};